<template>
  <section-block
    class="c-container"
    :class="{'with-gradient': withGradient && isBoxOpen,'header-central': headerCentral}"
    mobile-toggle
    :no-padding='noPadding'
    @mobile-toggle="isBoxOpen = !isBoxOpen"
  >
    <template slot="header">
      <h2>{{title}}</h2>
    </template>
    <a :href="viewLink" v-if="viewLink" slot="actions">{{viewText}}</a>
    <div class="c-container__content" :class="{'is-open':isBoxOpen}">
      <slot></slot>
    </div>
  </section-block>
</template>

<script>
export default {
  name: "BaseContainer",
  props: {
    title: {
      type: String,
      default: ""
    },
    viewLink: {
      type: String,
      default: ""
    },
    viewText: {
      type: String,
      default: "View All"
    },
    withGradient: {
      type: Boolean,
      default: false
    },
    headerCentral: {
      type: Boolean,
      default: true
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    noPadding: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isBoxOpen: false
    };
  },
  mounted() {
    this.isBoxOpen = this.isOpen;
  }
};
</script>

<style scoped lang="scss">
.c-container {
  position: relative;

  &__content {
    display: none;

    @media (min-width: 768px) {
      display: block;
    }

    &.is-open {
      display: block;
    }
  }

  header {
    h2 {
      @media screen and (min-width: 1024px) {
        padding-left: 20px;
      }
      font-size: 20px;
    }
    a {
      text-decoration: none;
      margin-right: 20px;
    }
  }

  &.with-gradient {
    &:after {
      width: 100%;
      height: 180px;
      bottom: 0;
      left: 0;
      content: "";
      background-image: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 1) 100%
      );
      z-index: 10;
      position: absolute;
      pointer-events: none;
    }
  }
}
</style>